import { render } from "./TheFooter.vue?vue&type=template&id=c8abbec4&scoped=true&lang=pug"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=c8abbec4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8abbec4"]])

export default __exports__